import BarChartWidget from './BarChartWidget'; 

export default BarChartWidget ; 